<script>
export default {
	data() {
		return {
			// Utiliza las mismas funciones de llenado que en datos basicos
			// Recuerda que los campos que se presentan los llenaras como se hizo anterior
			// En esta sección se muestran los clientes en agregados para complementar los datos que se solicitan
			// Haz clic en "X" para eliminar al cliente.
			// Haz clic para agregar estados financieros.
			// Selecciona los estados financieros
			// Haz clic en cargar para agregar los estados financieros.
			pfIntro:  [
				{
					target: '[data-v-step="pf_1"]',  // We're using document.querySelector() under the hood
					// header: {
					// 	title: 'Haz clic en la pestaña Clientes',
					// },
					content: `Bienvenido al simulador del Programa Financiero, el mismo te ayudará a conocer el flujo de trabajo.`
				},
				{
					target: '[data-v-step="pf_2"]',  // We're using document.querySelector() under the hood
					header: {
						title: 'Historial de análisis',
					},
					content: `Te presentamos la lista de análisis realizados y conocerás su estado de avance.`,
					params: {
						placement: 'bottom'
					},
				},
				{
					target: '[data-v-step="pf_3"]',  // We're using document.querySelector() under the hood
					// header: {
					// 	title: 'Haz clic en la pestaña Clientes',
					// },
					content: `Nombre del Grupo / Filial.`
				},
				{
					target: '[data-v-step="pf_4"]',  // We're using document.querySelector() under the hood
					// header: {
					// 	title: 'Haz clic en la pestaña Clientes',
					// },
					content: `Fecha de la última actualización.`
				},
				{
					target: '[data-v-step="pf_5"]',  // We're using document.querySelector() under the hood
					// header: {
					// 	title: 'Haz clic en la pestaña Clientes',
					// },
					content: `Estado actual.`
				},
				{
					target: '[data-v-step="pf_6"]',  // We're using document.querySelector() under the hood
					// header: {
					// 	title: 'Haz clic en la pestaña Clientes',
					// },
					content: `Avance.`
				},
				{
					target: '[data-v-step="pf_7"]',  // We're using document.querySelector() under the hood
					// header: {
					// 	title: 'Haz clic en la pestaña Clientes',
					// },
					content: `Ver datos.`
				},
				{
					target: '[data-v-step="pf_8"]',  // We're using document.querySelector() under the hood
					// header: {
					// 	title: 'Haz clic en la pestaña Clientes',
					// },
					content: `Editar.`
				},
				{
					target: '[data-v-step="pf_9"]',  // We're using document.querySelector() under the hood
					// header: {
					// 	title: 'Haz clic en la pestaña Clientes',
					// },
					content: `Permite crear una copia del análisis seleccionado.`
				},
				{
					target: '[data-v-step="pf_10"]',  // We're using document.querySelector() under the hood
					// header: {
					// 	title: 'Haz clic en la pestaña Clientes',
					// },
					content: `Eliminar.`
				},
				{
					target: '[data-v-step="pf_11"]',  // We're using document.querySelector() under the hood
					// header: {
					// 	title: 'Haz clic en la pestaña Clientes',
					// },
					content: `Búsqueda de cliente.`
				},
				{
					target: '[data-v-step="pf_12"]',  // We're using document.querySelector() under the hood
					header: {
						title: 'Crear nuevo análisis',
					},
					content: `Haz clic para iniciar un nuevo análisis.`
				},
				
			],
			pfNewAnalysis: [
				{
					target: '[data-v-step="pf_na_0"]',  // We're using document.querySelector() under the hood
					header: {
						title: 'Nuevo análisis.',
					},
					content: `Esta ventana te permite buscar un Grupo económico o filial, para iniciar el análisis financiero.`
				},
				{
					target: '[data-v-step="pf_na_1"]',  // We're using document.querySelector() under the hood
					content: `Selecciona búsqueda por Grupo.`
				},
				{
					target: '[data-v-step="pf_na_2"]',  // We're using document.querySelector() under the hood
					content: `Selecciona la plantilla Lite.`
				},
				{
					target: '[data-v-step="pf_na_3"]',  // We're using document.querySelector() under the hood
					content: `Escribe el nombre del cliente.`
				},
				{
					target: '[data-v-step="pf_na_4"]',  // We're using document.querySelector() under the hood
					content: `Haz clic en Buscar.`
				},
				{
					target: '[data-v-step="pf_na_5"]',  // We're using document.querySelector() under the hood
					header: {
						title: 'Lista de resultados.',
					},
					content: `Se muestran los resultados de búqueda.`
				},
				{
					target: '[data-v-step="pf_na_6"]',  // We're using document.querySelector() under the hood
					content: `Haz clic en el cliente.`
				},
				{
					target: '[data-v-step="pf_na_7"]',  // We're using document.querySelector() under the hood
					content: `Haz clic en la flecha para explorar la estructura del grupo.`
				},
				{
					target: '[data-v-step="pf_na_8"]',  // We're using document.querySelector() under the hood
					content: `Haz clic en el nombre del Grupo o filial para seleccionarlo.`,
					params: {
						placement: 'right'
					},
				},
				{
					target: '[data-v-step="pf_na_9"]',  // We're using document.querySelector() under the hood
					content: `Da clic.`,
					params: {
						placement: 'top'
					},
				},
				{
					target: '[data-v-step="pf_na_3"]',  // We're using document.querySelector() under the hood
					content: `Escribe el nombre correcto o ingresa el código de examen`
				},
				{
					target: '[data-v-step="pf_na_4"]',  // We're using document.querySelector() under the hood
					content: `Haz clic en Buscar`
				},
			],
			pfTabs: [
				{
					target: '[data-v-step="pf_tabs_0"]',  // We're using document.querySelector() under the hood
					header: {
						title: 'Barra de navegación',
					},
					content: `Ayuda a moverte entre los formularios del Programa Financiero.`,
					params: {
						placement: 'left',
						enableScrolling: false
					},
				},
				{
					target: '[data-v-step="pf_tabs_0_1"]',  // We're using document.querySelector() under the hood
					content: `Porcentaje de avance por sección.`,
					params: {
						placement: 'left',
						enableScrolling: false
					},
				},
				{
					target: '[data-v-step="pf_tabs_0_2"]',  // We're using document.querySelector() under the hood
					content: `Proporciona un resumen de los datos ingresados.`,
					params: {
						placement: 'left',
						enableScrolling: false
					},
				},
				{
					target: '[data-v-step="pf_tabs_1"]',  // We're using document.querySelector() under the hood
					content: `Haz clic.`,
					params: {
						placement: 'left',
						enableScrolling: false
					},
				},
				{
					target: '[data-v-step="pf_tabs_2"]',  // We're using document.querySelector() under the hood
					header: {
						title: 'Menu de Acciones',
					},
					content: `Son opciones de utilidad para el Programa Financiero.`,
					params: {
						placement: 'left',
						enableScrolling: false
					},
				},
				{
					target: '[data-v-step="pf_tabs_3"]',  // We're using document.querySelector() under the hood
					content: `Imprime la información ingresada.`,
					params: {
						placement: 'left',
						enableScrolling: false
					},
				},
				{
					target: '[data-v-step="pf_tabs_4"]',  // We're using document.querySelector() under the hood
					content: `Agrega información adicional del cliente.`,
					params: {
						placement: 'left',
						enableScrolling: false
					},
				},
			],
			pfDG: [
				{
					target: '[data-v-step="pf_dg_0"]',  // We're using document.querySelector() under the hood
					content: `Ingresa la información necesaria.`,
					params: {
						placement: 'top',
					},
				},
				{
					target: '[data-v-step="pf_dg_1"]',  // We're using document.querySelector() under the hood
					content: `Haz clic en los encabezados para mostrar la sección`,
					params: {
						placement: 'left',
					},
				},
				{
					target: '[data-v-step="pf_dg_2"]',  // We're using document.querySelector() under the hood
					content: `Ingresa la información necesaria.`,
					params: {
						placement: 'top',
					},
				},
				{
					target: '[data-v-step="pf_dg_3"]',  // We're using document.querySelector() under the hood
					content: `Haz clic en los encabezados para mostrar la sección`,
					params: {
						placement: 'left',
					},
				},
				{
					target: '[data-v-step="pf_dg_4"]',  // We're using document.querySelector() under the hood
					header: {
						title: 'Leveraged Lending.',
					},
					content: `Los datos de esta sección son ingresados por el Asesor de Riesgos.`,
					params: {
						placement: 'top',
					},
				},
				{
					target: '[data-v-step="pf_dg_5"]',  // We're using document.querySelector() under the hood
					
					content: `Haz clic para guardar el avance.`,
					params: {
						placement: 'left',
					},
				},
				{
					target: '[data-v-step="pf_tabs_0"]',  // We're using document.querySelector() under the hood
					
					content: `Continúa con las siguientes secciones.`,
					params: {
						placement: 'top',
						enableScrolling: false,
					},
				},
			],
			pfDB: [
				{
					target: '[data-v-step="pf_db_0"]',  // We're using document.querySelector() under the hood
					content: `Ingresa la información necesaria.`,
					params: {
						placement: 'top',
					},
				},
				{
					target: '[data-v-step="pf_db_1"]',  // We're using document.querySelector() under the hood
					content: `Existen datos precargados.`,
					params: {
						placement: 'left',
					},
				},
				{
					target: '[data-v-step="pf_db_2"]',  // We're using document.querySelector() under the hood
					content: `Ingresa información adicional.`,
					params: {
						placement: 'left',
					},
				},
				
				{
					target: '[data-v-step="pf_db_3"]',  // We're using document.querySelector() under the hood
					content: `Haz clic para adjuntar documentos. <br> <small>(Función disponible en casos reales)</small>.`,
					params: {
						placement: 'left',
					},
				},
				{
					target: '[data-v-step="pf_db_4"]',  // We're using document.querySelector() under the hood
					content: `Haz clic en los encabezados para mostrar la sección`,
					params: {
						placement: 'left',
					},
				},
				{
					target: '[data-v-step="pf_db_5"]',  // We're using document.querySelector() under the hood
					content: `Ingresa la información solicitada.`,
					params: {
						placement: 'left',
					},
				},
				{
					target: '[data-v-step="pf_db_6"]',  // We're using document.querySelector() under the hood
					content: `Haz clic para eliminar registros.`,
					params: {
						placement: 'left',
					},
				},
				{
					target: '[data-v-step="pf_db_7"]',  // We're using document.querySelector() under the hood
					content: `Haz clic para agregar registros.`,
					params: {
						placement: 'left',
					},
				},
				{
					target: '[data-v-step="pf_db_8"]',  // We're using document.querySelector() under the hood
					content: `<b>¡Perfecto!</b> continúa ingresando información.`,
					params: {
						placement: 'left',
					},
				},
				{
					target: '[data-v-step="pf_db_9"]',  // We're using document.querySelector() under the hood
					content: `Recuerda guardar la información para conservar tu avance.`,
					params: {
						placement: 'left',
					},
				},
			],
			pfFR: [
				{
					target: '[data-v-step="pf_rf_0"]',  // We're using document.querySelector() under the hood
					header: {
						title: 'Financial Risk',
					},
					content: `Ingresa la información financiera de cada Grupo o Filial del Programa Financiero.`,
					params: {
						placement: 'top',
						enableScrolling: false,
					},
				},
				{
					target: '[data-v-step="pf_rf_1"]',  // We're using document.querySelector() under the hood
					
					content: `Haz clic para agregar un Grupo o Filial.`,
					params: {
						placement: 'right',
						enableScrolling: false,
					},
				},
			],
			pfFREG: [
				{
					target: '[data-v-step="pf_rf_eg_0"]',  // We're using document.querySelector() under the hood
					header: {
						title: 'Estructura de Grupo.',
					},
					content: `Busca un Grupo o Filial para agregarla al Programa Financiero.`,
					params: {
						placement: 'bottom',
						enableScrolling: false,
					},
				},
				{
					target: '[data-v-step="pf_rf_eg_1"]',  // We're using document.querySelector() under the hood
					content: `Te ayuda a buscar el Grupo o Filial.`,
					params: {
						placement: 'right',
						enableScrolling: false,
					},
				},
				{
					target: '[data-v-step="pf_rf_eg_2"]',  // We're using document.querySelector() under the hood
					header: {
						title: 'Lista de resultados.',
					},
					content: `Se muestran los resultados de búqueda.`
				},
				{
					target: '[data-v-step="pf_rf_eg_3"]',  // We're using document.querySelector() under the hood
					content: `Haz clic en el cliente.`
				},
				{
					target: '[data-v-step="pf_rf_eg_4"]',  // We're using document.querySelector() under the hood
					content: `Haz clic en la flecha para explorar la estructura del grupo.`
				},
				{
					target: '[data-v-step="pf_rf_eg_5"]',  // We're using document.querySelector() under the hood
					content: `Haz clic en el nombre del Grupo o filial.`,
					params: {
						placement: 'right'
					},
				},
				{
					target: '[data-v-step="pf_rf_eg_6"]',  // We're using document.querySelector() under the hood
					content: `Haz clic en Agregar para guardar y continuar con el proceso.`,
					params: {
						placement: 'right'
					},
				},
			],
			pfFRTabs: [
				{
					target: '[data-v-step="pf_rf_tabs_0"]',  // We're using document.querySelector() under the hood
					content: `Se muestran los clientes agregados para completar los datos que se solicitan.`,
					params: {
						placement: 'left',
					},
				},
				{
					target: '[data-v-step="pf_rf_tabs_1"]',  // We're using document.querySelector() under the hood
					content: `Haz clic para mostrar los estados financieros disponibles.`,
					params: {
						placement: 'left',
						enableScrolling: false
					},
				},
				{
					target: '[data-v-step="pf_rf_tabs_2"]',  // We're using document.querySelector() under the hood
					content: `Selecciona los estados financieros a cargar.`,
					params: {
						placement: 'left',
						enableScrolling: false
					},
				},
				{
					target: '[data-v-step="pf_rf_tabs_3"]',  // We're using document.querySelector() under the hood
					content: `Haz clic.`,
					params: {
						placement: 'left',
						enableScrolling: false
					},
				},
				{
					target: '[data-v-step="pf_rf_tabs_4"]',  // We're using document.querySelector() under the hood
					content: `<b>Perfecto</b>, complementa los datos solicitados.`,
					params: {
						placement: 'left',
						enableScrolling: false
					},
				},
				{
					target: '[data-v-step="pf_rf_1"]',  // We're using document.querySelector() under the hood
					content: `Agrega otras filiales.`,
					params: {
						placement: 'right',
						enableScrolling: false
					},
				},
			],
			pfP: [
				{
					target: '[data-v-step="pf_p_0"]',  // We're using document.querySelector() under the hood
					content: `Se muestran los clientes agregados para complementar los datos requeridos.`,
					params: {
						placement: 'left',
						enableScrolling: false,
					},
				},
				{
					target: '[data-v-step="pf_p_1"]',  // We're using document.querySelector() under the hood
					content: `Complementa los datos requeridos.`,
					params: {
						placement: 'top',
						enableScrolling: false,
					},
				},
				{
					target: '[data-v-step="pf_p_2"]',  // We're using document.querySelector() under the hood
					content: `Agrega otras filiales.`,
					params: {
						placement: 'left',
						enableScrolling: false,
					},
				},
			]
		}
	}
}
</script>
<template>
	<div>
		<v-tour name="pfIntro" :steps="pfIntro">
			<template slot-scope="tour">
				<transition name="fade">
					<template v-for="(step, index) of tour.steps">
						<v-step v-if="tour.currentStep === index"
							:key="index"
							:step="step"
							:previous-step="tour.previousStep"
							:next-step="tour.nextStep"
							:stop="tour.stop"
							:is-first="tour.isFirst"
							:is-last="tour.isLast"
							:labels="tour.labels"
							>
							<template  v-if="[2,3,4,5,6,7,8,9,10].includes(tour.currentStep)">
								<div slot="content">
									<div class="d-flex align-items-center">
										<div class="flex-grow-1 w-100">
											{{step.content}}
										</div>
										<div>
											<button @click="tour.nextStep" class="s-btn s-btn--primary"><span class="icon-next"></span></button>
										</div>
									</div>
								</div>
								<div slot="actions"></div>
							</template>
							<template v-else-if="tour.currentStep === 11">
								<div slot="content" v-html="step.content">
								</div>
								<div slot="actions">
									<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary">Anterior</button> -->
									<!-- <button @click="tour.nextStep" class="s-btn s-btn--primary">Siguiente <span class="icon-next"></span></button> -->
								</div>
							</template>
							<template v-else>
								<div slot="content" v-html="step.content">
								</div>
								<div slot="actions">
									<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary">Anterior</button> -->
									<button @click="tour.nextStep" class="s-btn s-btn--primary">Siguiente <span class="icon-next"></span></button>
								</div>
							</template>
						</v-step>
					</template>
				</transition>
			</template>
		</v-tour>
		<v-tour name="pfNewAnalysis" :steps="pfNewAnalysis">
			<template slot-scope="tour">
				<transition name="fade">
					<template v-for="(step, index) of tour.steps">
						<v-step v-if="tour.currentStep === index"
							:key="index"
							:step="step"
							:previous-step="tour.previousStep"
							:next-step="tour.nextStep"
							:stop="tour.stop"
							:is-first="tour.isFirst"
							:is-last="tour.isLast"
							:labels="tour.labels"
							>
							<template  v-if="[1,2,3,10].includes(tour.currentStep)">
								<div slot="content">
									<div class="d-flex align-items-center">
										<div class="flex-grow-1 w-100" v-html="step.content"></div>
										<div>
											<button @click="tour.nextStep" class="s-btn s-btn--primary"><span class="icon-next"></span></button>
										</div>
									</div>
								</div>
								<div slot="actions"></div>
							</template>
							<template  v-else-if="[4,6,7,8,9,11].includes(tour.currentStep)">
								<div slot="content">
									<div class="d-flex align-items-center">
										<div class="flex-grow-1 w-100" v-html="step.content"></div>
									</div>
								</div>
								<div slot="actions"></div>
							</template>
							<template v-else>
								<div slot="content" v-html="step.content">
								</div>
								<div slot="actions">
									<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary">Anterior</button> -->
									<button @click="tour.nextStep" class="s-btn s-btn--primary">Siguiente <span class="icon-next"></span></button>
								</div>
							</template>
						</v-step>
					</template>
				</transition>
			</template>
		</v-tour>
		<v-tour name="pfTabs" :steps="pfTabs">
			<template slot-scope="tour">
				<transition name="fade">
					<template v-for="(step, index) of tour.steps">
						<v-step v-if="tour.currentStep === index"
							:key="index"
							:step="step"
							:previous-step="tour.previousStep"
							:next-step="tour.nextStep"
							:stop="tour.stop"
							:is-first="tour.isFirst"
							:is-last="tour.isLast"
							:labels="tour.labels"
							>
							<template  v-if="[1,2,5].includes(tour.currentStep)">
								<div slot="content">
									<div class="d-flex align-items-center">
										<div class="flex-grow-1 w-100" v-html="step.content"></div>
										<div>
											<button @click.stop="tour.nextStep" class="s-btn s-btn--primary"><span class="icon-next"></span></button>
										</div>
									</div>
								</div>
								<div slot="actions"></div>
							</template>
							<template  v-else-if="[3,6].includes(tour.currentStep)">
								<div slot="content">
									<div class="d-flex align-items-center">
										<div class="flex-grow-1 w-100" v-html="step.content"></div>
									</div>
								</div>
								<div slot="actions"></div>
							</template>
							<template v-else>
								<div slot="content" v-html="step.content">
								</div>
								<div slot="actions">
									<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary">Anterior</button> -->
									<button @click.stop="tour.nextStep" class="s-btn s-btn--primary">Siguiente <span class="icon-next"></span></button>
								</div>
							</template>
						</v-step>
					</template>
				</transition>
			</template>
		</v-tour>
		<v-tour name="pfDG" :steps="pfDG">
			<template slot-scope="tour">
				<transition name="fade">
					<template v-for="(step, index) of tour.steps">
						<v-step v-if="tour.currentStep === index"
							:key="index"
							:step="step"
							:previous-step="tour.previousStep"
							:next-step="tour.nextStep"
							:stop="tour.stop"
							:is-first="tour.isFirst"
							:is-last="tour.isLast"
							:labels="tour.labels"
							>
							<template  v-if="[].includes(tour.currentStep)">
								<div slot="content">
									<div class="d-flex align-items-center">
										<div class="flex-grow-1 w-100" v-html="step.content"></div>
										<div>
											<button @click.stop="tour.nextStep" class="s-btn s-btn--primary"><span class="icon-next"></span></button>
										</div>
									</div>
								</div>
								<div slot="actions"></div>
							</template>
							<template  v-else-if="[1,3,5,6].includes(tour.currentStep)">
								<div slot="content">
									<div class="d-flex align-items-center">
										<div class="flex-grow-1 w-100" v-html="step.content"></div>
									</div>
								</div>
								<div slot="actions"></div>
							</template>
							<template v-else>
								<div slot="content" v-html="step.content">
								</div>
								<div slot="actions">
									<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary">Anterior</button> -->
									<button @click.stop="tour.nextStep" class="s-btn s-btn--primary">Siguiente <span class="icon-next"></span></button>
								</div>
							</template>
						</v-step>
					</template>
				</transition>
			</template>
		</v-tour>
		<v-tour name="pfDB" :steps="pfDB">
			<template slot-scope="tour">
				<transition name="fade">
					<template v-for="(step, index) of tour.steps">
						<v-step v-if="tour.currentStep === index"
							:key="index"
							:step="step"
							:previous-step="tour.previousStep"
							:next-step="tour.nextStep"
							:stop="tour.stop"
							:is-first="tour.isFirst"
							:is-last="tour.isLast"
							:labels="tour.labels"
							>
							<template  v-if="[1,2,3,5,6,7,8].includes(tour.currentStep)">
								<div slot="content">
									<div class="d-flex align-items-center">
										<div class="flex-grow-1 w-100" v-html="step.content"></div>
										<div>
											<button @click.stop="tour.nextStep" class="s-btn s-btn--primary"><span class="icon-next"></span></button>
										</div>
									</div>
								</div>
								<div slot="actions"></div>
							</template>
							<template  v-else-if="[4].includes(tour.currentStep)">
								<div slot="content">
									<div class="d-flex align-items-center">
										<div class="flex-grow-1 w-100" v-html="step.content"></div>
									</div>
								</div>
								<div slot="actions"></div>
							</template>
							<template  v-else-if="[9].includes(tour.currentStep)">
								<div slot="content">
									<div class="d-flex align-items-center">
										<div class="flex-grow-1 w-100" v-html="step.content"></div>
									</div>
									<div slot="actions">
										<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary">Anterior</button> -->
										<button @click.stop="tour.stop" class="s-btn s-btn--primary">Entendido</button>
									</div>
								</div>
								<div slot="actions"></div>
							</template>
							<template v-else>
								<div slot="content" v-html="step.content">
								</div>
								<div slot="actions">
									<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary">Anterior</button> -->
									<button @click.stop="tour.nextStep" class="s-btn s-btn--primary">Siguiente <span class="icon-next"></span></button>
								</div>
							</template>
						</v-step>
					</template>
				</transition>
			</template>
		</v-tour>
		<v-tour name="pfFR" :steps="pfFR">
			<template slot-scope="tour">
				<transition name="fade">
					<template v-for="(step, index) of tour.steps">
						<v-step v-if="tour.currentStep === index"
							:key="index"
							:step="step"
							:previous-step="tour.previousStep"
							:next-step="tour.nextStep"
							:stop="tour.stop"
							:is-first="tour.isFirst"
							:is-last="tour.isLast"
							:labels="tour.labels"
							>
							<template  v-if="[].includes(tour.currentStep)">
								<div slot="content">
									<div class="d-flex align-items-center">
										<div class="flex-grow-1 w-100" v-html="step.content"></div>
										<div>
											<button @click.stop="tour.nextStep" class="s-btn s-btn--primary"><span class="icon-next"></span></button>
										</div>
									</div>
								</div>
								<div slot="actions"></div>
							</template>
							<template  v-else-if="[1].includes(tour.currentStep)">
								<div slot="content">
									<div class="d-flex align-items-center">
										<div class="flex-grow-1 w-100" v-html="step.content"></div>
									</div>
								</div>
								<div slot="actions"></div>
							</template>
							<template  v-else-if="[2000].includes(tour.currentStep)">
								<div slot="content">
									<div class="d-flex align-items-center">
										<div class="flex-grow-1 w-100" v-html="step.content"></div>
									</div>
									<div slot="actions">
										<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary">Anterior</button> -->
										<button @click.stop="tour.stop" class="s-btn s-btn--primary">Entendido</button>
									</div>
								</div>
								<div slot="actions"></div>
							</template>
							<template v-else>
								<div slot="content" v-html="step.content">
								</div>
								<div slot="actions">
									<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary">Anterior</button> -->
									<button @click.stop="tour.nextStep" class="s-btn s-btn--primary">Siguiente <span class="icon-next"></span></button>
								</div>
							</template>
						</v-step>
					</template>
				</transition>
			</template>
		</v-tour>
		<v-tour name="pfFREG" :steps="pfFREG">
			<template slot-scope="tour">
				<transition name="fade">
					<template v-for="(step, index) of tour.steps">
						<v-step v-if="tour.currentStep === index"
							:key="index"
							:step="step"
							:previous-step="tour.previousStep"
							:next-step="tour.nextStep"
							:stop="tour.stop"
							:is-first="tour.isFirst"
							:is-last="tour.isLast"
							:labels="tour.labels"
							>
							<template  v-if="[].includes(tour.currentStep)">
								<div slot="content">
									<div class="d-flex align-items-center">
										<div class="flex-grow-1 w-100" v-html="step.content"></div>
										<div>
											<button @click.stop="tour.nextStep" class="s-btn s-btn--primary"><span class="icon-next"></span></button>
										</div>
									</div>
								</div>
								<div slot="actions"></div>
							</template>
							<template  v-else-if="[3,4,5,6].includes(tour.currentStep)">
								<div slot="content">
									<div class="d-flex align-items-center">
										<div class="flex-grow-1 w-100" v-html="step.content"></div>
									</div>
								</div>
								<div slot="actions"></div>
							</template>
							<template  v-else-if="[2000].includes(tour.currentStep)">
								<div slot="content">
									<div class="d-flex align-items-center">
										<div class="flex-grow-1 w-100" v-html="step.content"></div>
									</div>
									<div slot="actions">
										<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary">Anterior</button> -->
										<button @click.stop="tour.stop" class="s-btn s-btn--primary">Entendido</button>
									</div>
								</div>
								<div slot="actions"></div>
							</template>
							<template v-else>
								<div slot="content" v-html="step.content">
								</div>
								<div slot="actions">
									<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary">Anterior</button> -->
									<button @click.stop="tour.nextStep" class="s-btn s-btn--primary">Siguiente <span class="icon-next"></span></button>
								</div>
							</template>
						</v-step>
					</template>
				</transition>
			</template>
		</v-tour>
		<v-tour name="pfFRTabs" :steps="pfFRTabs">
			<template slot-scope="tour">
				<transition name="fade">
					<template v-for="(step, index) of tour.steps">
						<v-step v-if="tour.currentStep === index"
							:key="index"
							:step="step"
							:previous-step="tour.previousStep"
							:next-step="tour.nextStep"
							:stop="tour.stop"
							:is-first="tour.isFirst"
							:is-last="tour.isLast"
							:labels="tour.labels"
							>
							<template  v-if="[0,2,4].includes(tour.currentStep)">
								<div slot="content">
									<div class="d-flex align-items-center">
										<div class="flex-grow-1 w-100" v-html="step.content"></div>
										<div>
											<button @click.stop="tour.nextStep" class="s-btn s-btn--primary"><span class="icon-next"></span></button>
										</div>
									</div>
								</div>
								<div slot="actions"></div>
							</template>
							<template  v-else-if="[1,3].includes(tour.currentStep)">
								<div slot="content">
									<div class="d-flex align-items-center">
										<div class="flex-grow-1 w-100" v-html="step.content"></div>
									</div>
								</div>
								<div slot="actions"></div>
							</template>
							<template  v-else-if="[5].includes(tour.currentStep)">
								<div slot="content">
									<div class="d-flex align-items-center">
										<div class="flex-grow-1 w-100" v-html="step.content"></div>
									</div>
									<div slot="actions">
										<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary">Anterior</button> -->
										<button @click.stop="tour.stop" class="s-btn s-btn--primary">Entendido</button>
									</div>
								</div>
								<div slot="actions"></div>
							</template>
							<template v-else>
								<div slot="content" v-html="step.content">
								</div>
								<div slot="actions">
									<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary">Anterior</button> -->
									<button @click.stop="tour.nextStep" class="s-btn s-btn--primary">Siguiente <span class="icon-next"></span></button>
								</div>
							</template>
						</v-step>
					</template>
				</transition>
			</template>
		</v-tour>
		<v-tour name="pfP" :steps="pfP">
			<template slot-scope="tour">
				<transition name="fade">
					<template v-for="(step, index) of tour.steps">
						<v-step v-if="tour.currentStep === index"
							:key="index"
							:step="step"
							:previous-step="tour.previousStep"
							:next-step="tour.nextStep"
							:stop="tour.stop"
							:is-first="tour.isFirst"
							:is-last="tour.isLast"
							:labels="tour.labels"
							>
							<template  v-if="[0,1].includes(tour.currentStep)">
								<div slot="content">
									<div class="d-flex align-items-center">
										<div class="flex-grow-1 w-100" v-html="step.content"></div>
										<div>
											<button @click.stop="tour.nextStep" class="s-btn s-btn--primary"><span class="icon-next"></span></button>
										</div>
									</div>
								</div>
								<div slot="actions"></div>
							</template>
							<template  v-else-if="[1000].includes(tour.currentStep)">
								<div slot="content">
									<div class="d-flex align-items-center">
										<div class="flex-grow-1 w-100" v-html="step.content"></div>
									</div>
								</div>
								<div slot="actions"></div>
							</template>
							<template  v-else-if="[2].includes(tour.currentStep)">
								<div slot="content">
									<div class="d-flex align-items-center">
										<div class="flex-grow-1 w-100" v-html="step.content"></div>
									</div>
									<div slot="actions">
										<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary">Anterior</button> -->
										<button @click.stop="tour.stop" class="s-btn s-btn--primary">Entendido</button>
									</div>
								</div>
								<div slot="actions"></div>
							</template>
							<template v-else>
								<div slot="content" v-html="step.content">
								</div>
								<div slot="actions">
									<!-- <button @click="tour.previousStep" class="s-btn s-btn--primary">Anterior</button> -->
									<button @click.stop="tour.nextStep" class="s-btn s-btn--primary">Siguiente <span class="icon-next"></span></button>
								</div>
							</template>
						</v-step>
					</template>
				</transition>
			</template>
		</v-tour>
	</div>
</template>
<style lang="scss" scoped>
::v-deep {
	.v-step{
		background-color: #0070D2;
		padding: 0.5rem;
		text-align: left;
	}
	.v-step__header{
		background-color: #045397;
		margin: -0.5rem -0.5rem .5rem;
	}
	.v-step .v-step__arrow{
		border-color: #0070D2;
	}
	.s-btn--primary{
		background-color: rgba($color: #000000, $alpha: 0.3);
		color: #fff;
		border: 0 none;
		border-radius: 0.15rem;
		margin-top: 0.25rem;
		margin-left: auto;
		margin-right: auto;
		display: block;
	}

	.v-step[x-placement^=bottom] .v-step__arrow{
		border-width: 0 .75rem 1.5rem .75rem;
		top: -1.5rem;
	}

	.v-step[x-placement^=right] .v-step__arrow{
		border-width: .75rem  1.5rem .75rem 0 ;
		left: -1.5rem;
	}
	.v-step[x-placement^=left] .v-step__arrow{
		border-width: .75rem 0 .75rem  1.5rem;
		right: -1.5rem;
	}
	.v-step[x-placement^=top] .v-step__arrow{
		border-width: 1.5rem .75rem 0 .75rem;
		bottom: -1.5rem;
	}

	.v-step[x-placement^=bottom] {
		margin-top: 1.5rem;
	}
	.v-step[x-placement^=top] {
		margin-bottom: 1.5rem;
	}
	.v-step[x-placement^=left] {
		margin-right: 1.5rem;
	}
	.v-step[x-placement^=right] {
		margin-left: 1.5rem;
	}
}
</style>